import React, { useEffect, useState } from 'react';

import ConfiguratorPrivateConnect from './ConfiguratorPrivateConnect';
import { useParams } from 'react-router-dom';

function ConfiguratorPrivateConnectParent(props) {
  const [Datareceived, setDatareceived] = useState({ data: [] });

  let InsertCountry = 'Germany';
  let para = useParams();
  if (para.count == 'it-it') {
    InsertCountry = 'Italy';
  }
  if (para.count == 'en') {
    InsertCountry = '';
  }

  const [addresses, setAddresses] = useState([
    { name: 'Address 1', latitude: 51.509865, longitude: -0.118092 },
    { name: 'Address 2', latitude: 51.5074, longitude: -0.1278 },
    { name: 'Address 3', latitude: 51.7867, longitude: 6.1295 },
  ]);
  let token = process.env.REACT_APP_PUBLIC_KEY2;
  useEffect(() => {
    if (props.locale) {
      const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      };
      fetch(
        'https://strapi-qrailing.azurewebsites.net/api/premiumcustomers?filters[Locale][$eq]=' +
          props.locale +
          '&fields[0]=DisplayName&fields[1]=GeoCoordinates&fields[2]=PostCode&fields[3]=Slug&fields[4]=City',
        requestOptions,
      )
        .then((res) => res.json())
        .then((json) => {
          console.log(json);
          setDatareceived(json);
          let returnaddresses = [];
          json.data.forEach((element) => {
            console.log(element);
            returnaddresses.push({
              name: element.attributes.DisplayName,
              latitude: parseFloat(element.attributes.GeoCoordinates.lat),
              longitude: parseFloat(element.attributes.GeoCoordinates.lon),
              postcode: element.attributes.PostCode,
              city: element.attributes.City,
              street: 'element.attributes.StreetNr',
              slug: element.attributes.Slug,
            });
          });
          console.log(addresses);
          setAddresses(returnaddresses);
        });
    }
  }, []);

  return (
    <>
      {props.PrivateData && (
        <ConfiguratorPrivateConnect
          addresses={addresses}
          targetPostcode={props.PrivateData.postcode}
          street={props.PrivateData.street}
          setInstallerId={props.setInstallerId}
          setnothingbelow={props.setnothingbelow}
          country={InsertCountry}
          custdata={Datareceived}
          setSelectStep={props.setSelectStep}
          Translations={props.Translations}
          PrivateData={props.PrivateData}
          AnnoyCustomer={props.AnnoyCustomer}
          ConfigLink={props.ConfigLink}
        ></ConfiguratorPrivateConnect>
      )}
    </>
  );
}

export default ConfiguratorPrivateConnectParent;
